// Cron Expression Explainer Tool — describe a cron schedule in plain English.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const cronExplainerTool: Tool = {
  id: "cron-explainer",
  name: () => m.cr_tool_name(),
  description: () => m.cr_tool_description(),
  icon: "⏱️",
  basePath: "/cron-expression-explainer",
  status: "stable",
  tags: ["cron", "crontab", "schedule", "developer"],
  pages: [
    {
      name: () => m.cr_nav_main(),
      path: "/cron-expression-explainer",
      description: () => m.cr_nav_main_desc(),
      icon: "⏱️",
    },
  ],
};
